import { render } from "./CardEmojiList.vue?vue&type=template&id=b08c8c28"
import script from "./CardEmojiList.vue?vue&type=script&lang=js"
export * from "./CardEmojiList.vue?vue&type=script&lang=js"

import "./CardEmojiList.vue?vue&type=style&index=0&id=b08c8c28&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__